export const LOCALES = {
    SPANISH: "es-cr"
};
